import { useTranslation } from "react-i18next";

interface CTASectionProps {
  title: string;
  subtitle: string;
  buttonText: string;
  variant?: "default" | "about";
}

export default function CTASection({
  title,
  subtitle,
  buttonText,
  variant = "default",
}: CTASectionProps) {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        <h2 className="font-serif font-bold text-3xl md:text-4xl text-foreground-950 mb-4">
          {title}
        </h2>
        <p className="text-foreground-500 text-base md:text-lg mb-8 max-w-xl mx-auto">
          {subtitle}
        </p>
        <button className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-secondary-700 text-white font-medium text-sm hover:bg-secondary-800 transition-all duration-200 cursor-pointer">
          {buttonText}
          <i className="ri-arrow-right-line"></i>
        </button>
        {variant === "default" && (
          <div className="mt-12 flex justify-center">
            <div className="flex -space-x-3">
              {[1, 2, 3, 4, 5].map((i) => (
                <div
                  key={i}
                  className={`w-12 h-12 rounded-full border-2 border-background-50 flex items-center justify-center ${
                    i % 2 === 0 ? "bg-accent-400" : "bg-primary-400"
                  } text-white text-xs font-bold`}
                >
                  {String.fromCharCode(64 + i)}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}